<template>
<!--  商品列表  -->
  <div>
    <div v-if="haveData" class="d-flex flex-row flex-wrap">
      <v-skeleton
        :loading="showGoods"
        v-for="(item, index) in initData"
        :key="index"
        width="230"
        class="mb-4 ske"
        tile
        type="image, article"
      >
        <v-card
          v-if="item.ssuList && item.ssuList.length"
          max-width="230"
          width="230"
          elevation="0"
          class="cardG"
          tile
          @click="navToGoodsDetail(item.ssuList[0].ssuCode)"
        >
          <v-img
            height="250"
            :src="imgHttp + item.skuImgMain"
          ></v-img>
          <v-card-title class="pt-2 pb-0 subtitle-1 text-no-wrap d-block text-truncate">
            <template v-if="item.ssuList.length > 1">
                <b v-if="item.hdActive" style="color: #B71210;">【活动】</b>
            </template>
            <template v-else>
              <b v-if="item.ssuList[0].eventMark === 10" style="color: #B71210;">【满送】</b>
              <b v-if="item.ssuList[0].eventMark === 20" style="color: #B71210;">【满赠】</b>
              <b v-if="item.ssuList[0].eventMark === 30" style="color: #B71210;">【满减】</b>
              <b v-if="item.ssuList[0].eventMark === 40" style="color: #B71210;">【折减】</b>
              <b v-if="item.ssuList[0].eventMark === 50" style="color: #B71210;">【特价】</b>
            </template>
            {{ item.ssuSkuName }}
          </v-card-title>
          <v-card-text>
            <div class="body-2 ys1"><span class="ys2">{{item.skuAlias}}</span> {{ item.ssuList[0].ssuSkuSpecDesc }}</div>
            <template v-if="item.ssuList[0].ssuMarketPrice">
              <div class="mt-3 caption" v-if="item.ssuList.length === 1"><s>市场价¥{{ item.ssuList[0].ssuMarketPrice ? item.ssuList[0].ssuMarketPrice.standardString : '0.00' }}</s></div>
              <div class="mt-3 caption" v-else><s>市场价¥{{ item.ssuList[0].ssuMarketPrice ? item.ssuList[0].ssuMarketPrice.standardString : '0.00' }} - {{ item.ssuList[item.ssuList.length - 1].ssuMarketPrice ? item.ssuList[item.ssuList.length - 1].ssuMarketPrice.standardString : '0.00' }}</s></div>
            </template>
            <div class="title ys2" v-if="item.ssuList.length === 1"><span class="caption">￥</span>{{ item.ssuList[0].ssuSellingPrice ? item.ssuList[0].ssuSellingPrice.standardString : '0.00' }}</div>
            <div class="title ys2" v-else><span class="caption">￥</span>{{ item.ssuList[0].ssuSellingPrice ? item.ssuList[0].ssuSellingPrice.standardString : '0.00' }} - <span class="caption">￥</span>{{ item.ssuList[item.ssuList.length - 1].ssuSellingPrice ? item.ssuList[item.ssuList.length - 1].ssuSellingPrice.standardString : '0.00' }}</div>
          </v-card-text>
        </v-card>
      </v-skeleton>
    </div>
    <div v-else class="pa-12">
      <v-img class="ma-auto" width="350" src="../../src/assets/img/wushuju.png"></v-img>
    </div>
  </div>
</template>

<script>
export default {
  name: 'goodsList',
  props: {
    initData: {
      type: Array
    }
  },
  components: {
    vSkeleton: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          ...props
        }, children)
      }
    }
  },
  data: () => ({
    showGoods: true,
    haveData: false,
    imgHttp: process.env.VUE_APP_IMAGE_URL
  }),
  watch: {
    initData () {
      if (this.initData && this.initData.length) {
        this.haveData = true
        setTimeout(() => {
          this.showGoods = false
        }, 2500)
        this.initData.forEach(item => {
          if (item.ssuList.length > 1) {
            item.ssuList.forEach(obj => {
              if (obj.eventMark) item.hdActive = true
            })
          }
        })
      } else {
        this.haveData = false
      }
    }
  },
  methods: {
    navToGoodsDetail (ssuCode) {
      this.$router.push({
        path: '/goodsDetail',
        query: {
          ssuCode: ssuCode
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .ys1{
    color: #666666;
  }
  .ys2{
    color: #E40404;
  }
  .ske{
    margin-right: 12.5px;
    &:nth-child(5n){
      margin-right: 0;
    }
  }
  .cardG{
    cursor: pointer;
  }

  ::v-deep .v-skeleton-loader__image{
    height: 244px !important;
  }
</style>
